import React from "react";
import { Helmet } from "react-helmet";

const E100 = () => {
  return (
    <div>
      <Helmet>
        <title>E100 - Scripture Union Thailand</title>
        <meta
          name="description"
          content="SU THAILAND ทำพันธกิจร่วมกับคริสตจักรและโรงเรียน เพื่อให้เด็กเยาวชนและครอบครัว ได้ยินข่าวประเสริฐของพระเจ้า"
        />
      </Helmet>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdmUcQPIfnSClxDkxGL0RAUCOxisHD_3yqkpcOCY2mLVSbLxw/viewform?embedded=true"
        width="100%"
        height="1200"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
};

export default E100;
